import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navigation from "./components/Navigation";
import AnnouncementBar from "./components/AnnouncementBar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import AddOns from "./components/AddOns";
import Testimonials from "./components/Testimonials";
import LeaveReview from "./components/LeaveReview";
import Referral from "./components/Referral";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AdminPage from "./pages/AdminPage";
import useReveal from "./hooks/useReveal";

function Landing() {
  useReveal();
  return (
    <div className="App bg-black text-white">
      <AnnouncementBar />
      <Navigation />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Gallery />
        <AddOns />
        <Testimonials />
        <LeaveReview />
        <Referral />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(212,175,55,0.4)",
            color: "#fff",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}
